/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="6.68"
        height="11.93"
        viewBox="0 0 6.68 11.93"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m.02 11.22.71.71L6.68 6 .71 0 0 .7 5.27 6 .02 11.22z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ChevronRightIcon';

export default Icon;
